import { useEffect, useState } from "react";
import { BuzerIcon } from "../../BuzerIcons";
import { Glyph, Modal } from "../../components/ui";
import { Lead, List, ListRow, RankChip, SectionHeader, Tag } from "../../components/ui/ds";
import { api } from "../../lib/api";
import { fmtDur, fmtShortDate } from "../../lib/format";
import { iconChipStyle } from "../../lib/icons-resolve";
import { st } from "../../styles.js";
import { Stat } from "./TaskDetail";

// Popup dlaždice „Víťazstvá vo výzvach" (Prehľad → Štatistiky): čo už dobehlo a ako som
// v tom skončil/a. Súťaž má poradie podľa zapísaného výsledku, bežná výzva podľa toho,
// kto z účastníkov nazbieral najviac splnení („poradie ukončenia"). Dáta: GET /api/wins.
export function WinsModal({ onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    let on = true;
    api("/api/wins").then((r) => { if (on) setD(r); }).catch(() => { if (on) setD({ items: [], err: true }); });
    return () => { on = false; };
  }, []);
  const items = (d && d.items) || [];
  // meta riadok: umiestnenie + to, čo výzvu/súťaž meria
  const score = (it) => {
    if (it.kind === "competition") {
      if (it.result == null) return "bez zápisu";
      return it.result_timer ? fmtDur(it.result) : `${it.result} ${it.metric}`;
    }
    const done = it.unit && it.unit !== "day" ? `${it.completions}/${it.expected}×` : `${it.completions}/${it.expected} dní`;
    return `${done} · ${it.success_pct} %`;
  };
  const place = (it) => (it.rank ? `${it.rank}. z ${it.total}` : "bez umiestnenia");
  return (
    <Modal center title="Víťazstvá vo výzvach" icon="crown" onClose={onClose} maxWidth={440}>
      {d == null ? (
        <div style={st.taskDesc}>Načítavam…</div>
      ) : (<>
        <div className="bz-tilerow">
          <Stat icon={<BuzerIcon name="crown" size={17} color="currentColor" />} value={d.first || 0} label="1. MIESTA" />
          <Stat icon={<BuzerIcon name="medal" size={17} color="currentColor" />} value={d.top3 || 0} label="NA PÓDIU" />
          <Stat icon={<BuzerIcon name="flag" size={17} color="currentColor" />} value={d.finished || 0} label="DOBEHNUTÉ" />
        </div>
        {/* 1. miesta a pódium sa rátajú zo súťaží — v bežnej výzve sa o prvé miesto delí
            každý, kto splnil všetko, takže by tie čísla stratili zmysel */}
        <div style={{ ...st.taskDesc, marginTop: 8 }}>
          {items.length === 0
            ? "Zatiaľ nič dobehnuté. Keď sa niektorá výzva alebo súťaž skončí, nájdeš tu svoje umiestnenie."
            : "Prvé miesta a pódium sa rátajú zo súťaží; pri bežných výzvach je to poradie ukončenia — kto nazbieral najviac splnení."}
        </div>
        {items.length > 0 && (<>
          <SectionHeader label="Poradie ukončenia" count={items.length} style={{ margin: "16px 2px 6px" }} />
          <List>
            {items.map((it) => (
              <ListRow key={`${it.kind}-${it.id}`}
                rank={<RankChip place={it.rank} size="sm" />}
                lead={<Lead shape="circle" size="sm" style={iconChipStyle(it.icon_color)}>
                  <Glyph icon={it.icon} size={17} fallback={it.kind === "competition" ? "trophy" : "flag"} />
                </Lead>}
                title={<>
                  {it.name}
                  {it.rank === 1 && it.kind === "competition" && <Tag tone="brand" size="xs" icon="crown">Víťazstvo</Tag>}
                </>}
                meta={`${place(it)} · ${score(it)}`}
                trailing={<span style={st.taskDesc}>{it.ended ? fmtShortDate(it.ended) : ""}</span>} />
            ))}
          </List>
        </>)}
      </>)}
    </Modal>
  );
}
